import React, { createContext } from 'react';
import { setInitialBannerCounters } from './helpers';
const BannerContext = createContext({});
const BannerContextProvider = ({
  children,
  siblings,
  banners,
  pbOptions
}) => {
  const bannerCounters = setInitialBannerCounters(banners);
  const bannerPositionCounter = {
    counter: 0
  };
  const blockTracker = {
    lastBlockType: null
  };
  return /*#__PURE__*/React.createElement(BannerContext.Provider, {
    value: {
      banners,
      bannerCounters,
      bannerPositionCounter,
      siblings,
      pbOptions,
      blockTracker
    }
  }, children);
};
export { BannerContext, BannerContextProvider };
//# sourceMappingURL=index.js.map